import React, { createContext, useContext, useState } from "react";
import LoadingModal from "../components/common/LoadingModal";

const LoadingContext = createContext();

export const useLoading = () => {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error("useLoading must be used within a LoadingProvider");
  }
  return context;
};

export const LoadingProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState("Loading...");
  const [loadingSubtitle, setLoadingSubtitle] = useState("");

  const showLoading = (message = "Loading...", subtitle = "") => {
    setLoadingMessage(message);
    setLoadingSubtitle(subtitle);
    setIsLoading(true);
  };

  const hideLoading = () => {
    setIsLoading(false);
    setLoadingMessage("Loading...");
    setLoadingSubtitle("");
  };

  const value = {
    isLoading,
    showLoading,
    hideLoading,
    loadingMessage,
    loadingSubtitle,
  };

  return (
    <LoadingContext.Provider value={value}>
      {children}
      <LoadingModal
        isVisible={isLoading}
        message={loadingMessage}
        subtitle={loadingSubtitle}
      />
    </LoadingContext.Provider>
  );
};

export default LoadingContext;
